import "./TaxFeeProtection.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import KeyBenefits from "./sections/KeyBenefits";
import HowItWorks from "./sections/HowItWorks";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import GetAQuote from "./sections/GetAQuote";
import Footer from "@/reusable_sections/Footer";
export default function TaxFeeProtectionPage() {
  return <div>
      <Header />
      <Hero />
      <KeyBenefits />
      <HowItWorks />
      <FrequentlyAskedQuestions />
      <GetAQuote />
      <Footer />
    </div>;
}